






















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Part, ProductItem } from "../../common/interfaces";
import Store from "@/store/store";
import axios from "axios";
import DetailHeader from "../DetailHeader.vue";
import MiscPart from "./MiscPart.vue";
import store from "@/store/store";
import { ActionNames } from "@/store/actions";
import "./QuotedParts.scss";

@Component({
  components: {
    DetailHeader,
    MiscPart
  }
})
export default class QuotedParts extends Vue {
  @Prop() public parts: Part[];
  public deletingIndex: number = -1;
  public addMiscPart: boolean = false;
  public miscPart: ProductItem;

  public rowStyles() {
    return "height: 55px";
  }

  get totalQuotes() {
    const decimals = this.parts[0] ? this.parts[0].SellDecimals || 2 : 2;
    return this.parts.reduce((p, c) => p + Number.parseFloat(c.DisplayPrice), 0).toFixed(decimals);
  }

  public addMiscPartClicked() {
    this.addMiscPart = true;
  }

  public miscPartClosed() {
      this.addMiscPart = false;
  }

  public confirmDelete(rowIndex: number) {
    this.deletingIndex = rowIndex;
  }

  public async deleteRow(rowIndex: number, row: Part) {
    try {
      this.deletingIndex = -1;
      await store.dispatch(ActionNames.RemovePartFromQuote, row.LineId);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48
      });
    }    
  }
}
